<pla-main-nav-chips></pla-main-nav-chips>
<div class="lg-root">
  <main class="lg-wrap">
    <nav class="lg-crumb" aria-label="Breadcrumb"><a routerLink="/">Home</a> › Data Deletion</nav>
    <p class="lg-eyebrow">Legal</p>
    <h1 class="lg-h1">Data Deletion</h1>
    <p class="lg-updated">Last updated: 1 November 2026</p>

    <div class="lg-body">
      <p class="lg-lede">
        At PlateX, you have the right to request the deletion of personal information associated with your account.
      </p>
      <p>This page explains how to submit a deletion request and what happens afterwards.</p>

      <section class="lg-section">
        <h2 class="lg-h2">How to request deletion</h2>
        <p>To request the deletion of your PlateX account and associated personal information:</p>
        <ol>
          <li>
            Email <a href="mailto:info@platex.co.uk">info&#64;platex.co.uk</a> using the email address associated with
            your PlateX account.
          </li>
          <li>Use the subject line <b>Data Deletion Request</b>.</li>
          <li>State that you would like your PlateX account and associated personal information deleted.</li>
        </ol>
        <p>If you registered using Facebook, Google or another connected service, please mention this in your request.</p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">What happens next?</h2>
        <p>Once we receive your request:</p>
        <ul>
          <li>We may ask you to verify your identity to protect your account against unauthorised deletion.</li>
          <li>We will review the personal information associated with your account.</li>
          <li>
            We will delete or anonymise eligible personal information, including account details, saved registrations,
            alerts and preferences.
          </li>
          <li>We will confirm when your request has been completed.</li>
        </ul>
        <p>We aim to respond within one calendar month, in accordance with applicable UK data protection requirements.</p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">Information we may need to retain</h2>
        <p>
          In certain circumstances, we may need to retain limited information to comply with legal obligations, maintain
          security, prevent fraud or establish, exercise or defend legal claims.
        </p>
        <p>
          Any information retained will be limited to what is necessary and handled in accordance with our
          <a routerLink="/privacy-policy">Privacy Policy</a>.
        </p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">Facebook and third-party sign-in</h2>
        <p>
          If you used Facebook or another third-party service to access PlateX, you can request deletion of the personal
          information associated with that connection using the same process.
        </p>
        <p>
          Removing PlateX from your Facebook account does not necessarily delete information already held by PlateX. To
          request deletion of that information, please email us.
        </p>
      </section>

      <section class="lg-contact">
        <h2 class="lg-h2">Contact</h2>
        <p>For data deletion requests or questions about your personal information:</p>
        <dl>
          <dt>Email</dt>
          <dd><a href="mailto:info@platex.co.uk">info&#64;platex.co.uk</a></dd>
          <dt>Website</dt>
          <dd><a href="https://www.platex.co.uk">www.platex.co.uk</a></dd>
        </dl>
        <p>
          For further information about how we handle personal data, please read our
          <a routerLink="/privacy-policy">Privacy Policy</a>.
        </p>
      </section>
    </div>
  </main>
</div>
